import { render, staticRenderFns } from "./addNewUserGuide.vue?vue&type=template&id=ed32ed80&scoped=true"
import script from "./addNewUserGuide.vue?vue&type=script&lang=js"
export * from "./addNewUserGuide.vue?vue&type=script&lang=js"
import style0 from "./addNewUserGuide.vue?vue&type=style&index=0&id=ed32ed80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed32ed80",
  null
  
)

export default component.exports